import React from "react";
import Flatpickr from 'react-flatpickr';
import {German} from 'flatpickr/dist/l10n/de';
import {english as English} from 'flatpickr/dist/l10n/default';
import {useField} from "formik";
import Form from "react-bootstrap/Form";
import {FormattedMessage, useIntl} from "react-intl";
import I18nText from "../i18n/I18nText";

const PICKER_DATE_FORMAT = 'Y-m-dTH:i:S'; // Zeitzonen agnostischer 'ISO 8601 like' datetime String

const FLATPICKR_DATETIME_ALT_FORMATS = {
    de: 'd.m.Y H:i',
    en: 'Y-m-d H:i'
};

const FLATPICKR_LOCALES = {
    de: German,
    en: English
};

function createFlatPickrOptions(locale, invalid) {
    return {
        wrap: true,
        altFormat: FLATPICKR_DATETIME_ALT_FORMATS[locale],
        dateFormat: PICKER_DATE_FORMAT,
        altInput: true,
        altInputClass: invalid ? 'is-invalid' : '',
        locale: FLATPICKR_LOCALES[locale],
        time_24hr: true,
        enableTime: true,
        allowInput: true,
        minuteIncrement: 15,
        clickOpens: false
    }
}

const FormikDateTime = (({name, label, options = {}}) => {
    const intl = useIntl();
    const [field, meta, helpers] = useField(name)

    const flatpickrOptions = {
        ...createFlatPickrOptions(intl.locale, meta.invalid),
        ...options
    }

    return (
        <Flatpickr
            className={'form-group'}
            options={flatpickrOptions}
            onChange={(dates, dateString) => {
                //const value = moment.tz(dateString, PICKER_TIME_ZONE).format(MOMENT_DATE_FORMAT);
                helpers.setValue(dateString)
            }}
            value={field.value}
        >
            {label && <Form.Label>
                <I18nText content={label}/>
            </Form.Label>}
            <div className="input-group">
                <div className="input-group-prepend">
                    <button className="btn btn-outline-primary" type="button" data-toggle>
                        <i className="fa fa-calendar" aria-hidden="true"/>
                    </button>
                </div>
                <input type="text" className="form-control" data-input />
                <div className="input-group-append">
                    <button className="btn btn-outline-primary" type="button" data-clear>
                        <i className="fa fa-times" aria-hidden="true"/>
                    </button>
                </div>
            </div>
            {meta.error && <div className="invalid-feedback" style={{display: 'block'}}>
                <FormattedMessage id={meta.error}/>
            </div>}
        </Flatpickr>
    )
})

export default FormikDateTime